import divanImg from './images/divany.jpg';
import stolyImg from './images/stoly.jpg';
import moduleImg from './images/module.jpg';
import tekstilImg from './images/tekstil.jpg';

import type { CategoryHash } from '../../typings';

type Data = {
  [key in CategoryHash]?: {
    link?: string;
    image: string;
    id: string;
  };
};

export const categoriesData: Data = {
  'Диваны и кресла': {
    link: '/category/promo-dofamin?types%5B%5D=54&types%5B%5D=1&types%5B%5D=401&types%5B%5D=37&types%5B%5D=304&types%5B%5D=67&types%5B%5D=212&types%5B%5D=58&types%5B%5D=254',
    image: divanImg,
    id: 'sofas',
  },
  'Столы и стулья': {
    link: '/category/promo-dofamin?types%5B%5D=10&types%5B%5D=58&types%5B%5D=168&types%5B%5D=29',
    image: stolyImg,
    id: 'tables',
  },
  'Модульные решения': {
    link: '/category/promo-dofamin?types%5B%5D=254&types%5B%5D=54&types%5B%5D=304',
    image: moduleImg,
    id: 'module',
  },
  'Текстиль для дома и сада': {
    link: '/category/promo-dofamin?types%5B%5D=326&types%5B%5D=227&types%5B%5D=316&types%5B%5D=63&types%5B%5D=22',
    image: tekstilImg,
    id: 'textile',
  },
};
